import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import '../../../scss/components/pages/signTime.scss';
import 'react-datepicker/dist/react-datepicker.css';
import API from '../../../middleware/API';


class ExpectWorkTimeByDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      finalWorkByday:[]
    }
  }
  
  componentDidMount() {
    let { day } = this.props.match.params;
    API.get('/Event/FinalWorkTimeSheetDetail?date='+day).then(
      (response) => {
        this.setState({finalWorkByday:response})
      }
    );
  }

  render() {
    let { day } = this.props.match.params;
    let { finalWorkByday } = this.state;
    let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
    let regExp = new RegExp(reg);
    if(!regExp.test(day)){
    　　return <Redirect to='/errorPage' />
    }
    let newRecords = [];
    finalWorkByday.forEach((item) => {
      let newItem = {
        id: item.id,
        name: item.name,
        jobType: item.jobType,
        actualDate: item.actualDate,
        firstSignId: item.data[0] ? item.data[0].id : '無資料',
        firstSignIntime: item.data[0] ? item.data[0].actualSignInTime : '無資料',
        firstSignOuttime: item.data[0] ? item.data[0].actualSignOutTime : '無資料',

        secondSignId: item.data[1] ? item.data[1].id : '無資料',
        secondSignIntime: item.data[1] ? item.data[1].actualSignInTime : '無資料',
        secondSignOuttime: item.data[1] ? item.data[1].actualSignOutTime : '無資料',

        thirdSignId: item.data[2] ? item.data[2].id : '無資料',
        thirdSignIntime: item.data[2] ? item.data[2].actualSignInTime : '無資料',
        thirdSignOuttime: item.data[2] ? item.data[2].actualSignOutTime : '無資料',
        totalWorkTime: item.totalWorkTime,
        pay: item.pay,
        overHour: item.overHour,
        overPay: item.overPay,
      }
      newRecords.push(newItem);
    });
    return (
    <div className="p-signTime">
      <div className="u-block">
        <div className="u-title">{ day } 最終工時</div>
        <div className="sign-notice">
      <div className="u-notice">註:薪資成本至多8小時計算</div>
        </div>
        <div className="u-table-responsive">
          <table className="u-table u-table-border u-table-striped">
            <thead>
              <tr>
                <th>員工編號</th>
                <th>姓名</th>
                <th>職位</th>
                <th>實際簽到日</th>
                <th>第一段簽到</th>
                <th>第一段簽退</th>
                <th>第二段簽到</th>
                <th>第二段簽退</th>
                <th>第三段簽到</th>
                <th>第三段簽退</th>
                <th>總工時</th>
                <th>薪資成本</th>
                <th>加班時數</th>
                <th>加班成本</th>
              </tr>
            </thead>
            <tbody>
              {
                newRecords.map((item, index) => (
                  <tr key={ index }>
                    <td>{ item.id }</td>
                    <td>{ item.name }</td>
                    <td>{ item.jobType}</td>
                    <td>{ item.actualDate }</td>
                    <td>{item.firstSignIntime === null ? '無資料' : item.firstSignIntime}</td>
                    <td>{item.firstSignOuttime === null ? '無資料' : item.firstSignOuttime}</td>
                    <td>{item.secondSignIntime === null ? '無資料' : item.secondSignIntime}</td>
                    <td>{item.secondSignOuttime === null ? '無資料' : item.secondSignOuttime}</td>
                    <td>{item.thirdSignIntime === null ? '無資料' : item.thirdSignIntime}</td>
                    <td>{item.thirdSignOuttime === null ? '無資料' : item.thirdSignOuttime}</td>
                    <td>{item.totalWorkTime.toFixed(1) }</td>
                    <td>{item.pay }</td>
                    <td>{item.overHour }</td>
                    <td>{item.overPay }</td>
                  </tr>)
                )
              }
            </tbody>
          </table>
        </div>
        <div className="u-notice">※無資料和店長確認。</div>
      </div>
    </div>
    )
  }
}



export default ExpectWorkTimeByDay;